<template>
  <header class='mt-3 mb-2 index-header' title='teste'>
    <v-layout justify-center row wrap>
      <v-flex>
        <h1 class='logo text-center'>
          <router-link :to="{name:'login'}">
            <img src='@/assets/img/logo-ek.png'>
          </router-link>
        </h1>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex md8 xs12>
        <h1 class='index-header-title mt-3 mb-2'>{{ $t(this.$props.title) }}</h1>
      </v-flex>
    </v-layout>
  </header>
</template>

<script>
export default {
  name: 'loading',
  props: {
    title: ''
  },
  computed: {
    lang() {
      return this.$cookies.get('lang');
    }
  }
};
</script>

<style lang='scss' scoped>
.index-header {
  &-title {
    font-size: 42px;
    letter-spacing: 0.02em;
  }
  
  .logo {
    margin: 0;
    
    img {
      width: 100%;
      max-width: 188px;
    }
  }
  
  @media only screen and (max-width: 620px) {
    &-title {
      font-size: 30px;
    }
  }
}
</style>
